import React from 'react';
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { FaMapMarkerAlt } from 'react-icons/fa';
import servicesData from '../../data/servicesData';
import ServiceCategory from './ServiceCategory';
import ServiceContact from './ServiceContact';

function ServiceSidebar() {
    return (
        <div className="service-details-sidebar">
            <div className="single-service-sidebar">
                <div className="sidebar-title">
                    <h3>Toate Serviciile</h3>
                </div>
                <ul>
                    {servicesData.map(service => (
                        <ServiceCategory
                            key={service.id}
                            link={`/servicii/${service.slug}`}
                            category={service.title}
                        />
                    ))}
                </ul>
            </div>
            <div className="single-service-sidebar site_info_widget">
                <div className="sidebar-title">
                    <h3>Contactează-ne</h3>
                </div>
                <div className="contact-us">
                    <ServiceContact
                        title="Telefon"
                        text="0724.273.258"
                        icon={<AiOutlinePhone />}
                    />
                    <ServiceContact
                        title="Email"
                        text="office@reparatiiasfalt.ro"
                        icon={<AiOutlineMail />}
                    />
                    <ServiceContact
                        title="Adresă"
                        text="Strada Bujorilor 4, Măgurele"
                        icon={<FaMapMarkerAlt />}
                    />
                </div>
            </div>
        </div>
    );
}

export default ServiceSidebar;
